import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from './translations/en/common.json';
import companySettings from './translations/en/companySettings.json';
import components from './translations/en/components.json';
import customerNotifications from './translations/en/customerNotifications.json';
import generalCompanySettings from './translations/en/generalCompanySettings.json';
import notifications from './translations/en/notifications.json';
import shopify from './translations/en/shopify.json';
import webhooks from './translations/en/webhooks.json';
import zapier from './translations/en/zapier.json';

i18next
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    interpolation: { escapeValue: false }, // React already does escaping
    resources: {
      en: {
        common,
        companySettings,
        components,
        customerNotifications,
        generalCompanySettings,
        notifications,
        shopify,
        webhooks,
        zapier,
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    saveMissing: true,
    missingKeyHandler: (lng: string[], namespace: string, key: string) => {
      console.error(`Failed to find i18n key in namespace ${namespace}: ${key}`);
    },
  });

export default i18next;
